import { render, staticRenderFns } from "./PartnersHome.vue?vue&type=template&id=6a01f498&scoped=true&"
import script from "./PartnersHome.vue?vue&type=script&lang=js&"
export * from "./PartnersHome.vue?vue&type=script&lang=js&"
import style0 from "./PartnersHome.vue?vue&type=style&index=0&id=6a01f498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01f498",
  null
  
)

export default component.exports